import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon, D } from "../search/icons";
import { NAV } from "../CabShell";

/**
 * Bottom mobile navigation from the wireframes (`.mobile-nav`, styled by every page's
 * scoped CSS). «Меню» opens a sheet with the full cabinet navigation, because the
 * sidebar is hidden on phones.
 */
const ITEMS = [
  { label: "Главная", to: "/", d: D.home },
  { label: "Поиск", to: "/search", d: D.search },
  { label: "Создать", to: "/order", d: D.plus },
  { label: "Чаты", to: "/chats", d: D.chat },
];

export default function MobileNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const active = (to) => NAV.find((n) => n.to === to)?.match(pathname);
  const inMain = ITEMS.some((i) => active(i.to));

  return (
    <>
      <nav className="mobile-nav" aria-label="Мобильное меню">
        {ITEMS.map((i) => (
          <button key={i.to} type="button" data-action={i.to === "/order" ? "publish" : undefined} className={active(i.to) ? "active" : ""} onClick={() => navigate(i.to)}>
            <Icon d={i.d} />
            {i.label}
          </button>
        ))}
        <button type="button" className={open || !inMain ? "active" : ""} aria-expanded={open} onClick={() => setOpen((v) => !v)}>
          <Icon d={D.menu} />
          Меню
        </button>
      </nav>
      {open && (
        <div
          role="presentation"
          onClick={(e) => e.target === e.currentTarget && setOpen(false)}
          style={{ position: "fixed", inset: 0, zIndex: 60, background: "#06142b66", display: "flex", alignItems: "flex-end" }}
        >
          <div
            role="dialog"
            aria-label="Меню"
            style={{ width: "100%", maxHeight: "80vh", overflow: "auto", background: "#fff", borderRadius: "16px 16px 0 0", padding: "12px 12px 20px", display: "grid", gap: 2 }}
          >
            {NAV.map((n) => (
              <button
                key={n.to}
                type="button"
                onClick={() => navigate(n.to)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  height: 46,
                  padding: "0 12px",
                  borderRadius: 10,
                  fontSize: 15,
                  textAlign: "left",
                  color: n.match(pathname) ? "#0058ef" : "#31466f",
                  background: n.match(pathname) ? "#e5efff" : "transparent",
                  fontWeight: n.match(pathname) ? 600 : 400,
                }}
              >
                <Icon d={n.d} />
                {n.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
